export default __webpack_public_path__ + "static/media/Razhar.3c0582d6.jpg";